"use client"

import { useLocale } from "./use-locale"
import { translations, type Translations } from "@/locales/translations"

export function useTranslations(): Translations & {
  t: (key: keyof Translations, params?: Record<string, string | number>) => string
} {
  const locale = useLocale()
  const currentTranslations = translations[locale] || translations.nl

  const t = (key: keyof Translations, params?: Record<string, string | number>): string => {
    let text = currentTranslations[key] || translations.nl[key] || key.toString()

    if (params) {
      Object.entries(params).forEach(([paramKey, paramValue]) => {
        text = text.replace(new RegExp(`{${paramKey}}`, "g"), paramValue.toString())
      })
    }

    return text
  }

  return {
    ...currentTranslations,
    t,
  }
}
